export interface FileModel{
    fileName:string, 
    content:string, 
}


export function fileToBase64(file: File) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
  
      reader.onload = (event) => {
        // resolve((event?.target?.result as string).split(',')[1]);
        if (event.target?.result && typeof event.target.result === 'string') {
            resolve(event.target.result.split(',')[1]);
          } else {
            reject(new Error('Invalid file data'));
          }
      };
  
      reader.onerror = (error) => {
        reject(error);
      };
  
      reader.readAsDataURL(file);
    });
  }
  export async function setFileModel(file: File): Promise<FileModel>{  
    
    var b64;
    b64= await  fileToBase64(file).then((str)=> b64=str).catch((err)=> 
    {b64="";
    console.log(err);}
    );
    //por ahora asumir
    return{
        fileName: file.name,
        content: b64 as string,
    }
}
export async function setFileModelWithName(file: File, name:string): Promise<FileModel>{  
    
  var b64;
  b64= await  fileToBase64(file).then((str)=> b64=str).catch((err)=> 
  {b64="";
  console.log(err);}
  );
  //por ahora asumir
  return{
      fileName: name,
      content: b64 as string,
  }
}

export function setListFileModel(data: Array<any>): Array<FileModel>{
    let listFile: Array<FileModel> = [];
    data.forEach(async (item) => {
        const adjunto: FileModel =await  setFileModel(item)
        listFile.push(adjunto);
    });
    return listFile;
}